import Vue from 'vue'
import { Validator } from 'vee-validate'
import { Component, Prop, Inject } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import SectionBase from '@/mixins/SectionBase';
import field from '@/directives/field';
import { SERVICE_NAMESPACE } from '@/store/mod/service_form';

const Base = Vue.extend({
  directives: {
    field: field(SERVICE_NAMESPACE),
  },
})

@Component
export default class ServiceSectionBase extends Base {
  public show (field: string): boolean {
    return this.$store.getters['serviceForm/show'](field)
  }

  public value (field: string): string | boolean | undefined {
    const val = this.$store.getters['serviceForm/fieldValue'](field)
    if (moment.isMoment(val)) {
      return (val as Moment).format('DD/MM/YYYY')
    } else {
      return val
    }
  }
}
